var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentLoader",
    { attrs: { height: "100", primaryColor: "rgb(220,220,220)" } },
    [
      _vm.loaderType === "avatar"
        ? _c("circle", { attrs: { cx: "130", cy: "90", r: "120" } })
        : _vm.loaderType === "column"
        ? _c("rect", {
            attrs: {
              x: "0",
              y: "20",
              rx: _vm.dtRadius,
              ry: _vm.dtRadius,
              width: "350",
              height: "40"
            }
          })
        : [
            _c("rect", {
              attrs: {
                x: "0",
                y: "30",
                rx: _vm.dtRadius,
                ry: _vm.dtRadius,
                width: "350",
                height: "30"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "0",
                y: "70",
                rx: _vm.dtRadius,
                ry: _vm.dtRadius,
                width: "170",
                height: "20"
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7b34758", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7b34758","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/loaders/profile-pagination-loader/template.html
// module id = null
// module chunks = 